$(document).ready(function ($) {
  $('.js-countdown').each(function () {
    initCountdown($(this));
  });
});

function initCountdown($countdown) {
  const end = new Date($countdown.data('end')).getTime();
  const $units = $countdown.find('.js-countdown-units');
  const $end = $countdown.find('.js-countdown-end');
  let interval;

  function setUnit(unit, value) {
    const $value = $units.find(`[data-unit='${unit}']`);
    const $key = $value.siblings('.key');

    $value.text(value);
    $key.text(value === 1 ? $key.data('singular') : $key.data('plural'));
  }

  function tick() {
    const remaining = Math.floor((end - Date.now()) / 1000);

    if (remaining <= 0) {
      clearInterval(interval);
      $units.addClass('d-none');
      $end.removeClass('d-none');
      return;
    }

    setUnit('days', Math.floor(remaining / 86400));
    setUnit('hours', Math.floor((remaining % 86400) / 3600));
    setUnit('minutes', Math.floor((remaining % 3600) / 60));
    setUnit('seconds', remaining % 60);
  }

  interval = setInterval(tick, 1000);
  tick();
}
